import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/components/landing/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/landing/marketing-site.css");
;
import(/* webpackMode: "eager", webpackExports: ["StoreDownloadButtons"] */ "/app/components/landing/StoreDownloadButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"components/landing/MarketingSiteShell.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-marketing-manrope\"}],\"variableName\":\"manrope\"}");
